// CSV writing helpers (RFC 4180). Pure.

export function csvField(value: unknown): string {
  if (value === undefined || value === null) return '';
  const s = String(value);
  return /[",\r\n]/.test(s) ? '"' + s.replace(/"/g, '""') + '"' : s;
}

export function csvLine(values: unknown[]): string {
  return values.map(csvField).join(',') + '\n';
}
